import React from "react";
import { Button } from "react-materialize";

export default function MyProfileRightBtnChange({ data, handleEvents }) {
  return (
    <Button
      className=""
      id="btn-change"
      node="button"
      waves="light"
      onClick={handleEvents}
      style={{
        borderRadius: "8px",
        display: "block",
        margin: "0 auto"
      }}
    >
      Change
    </Button>
  );
}
